import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { CookieModule } from 'ngx-cookie';

export const appConfig: ApplicationConfig = {
  providers: [importProvidersFrom(HttpClientModule, CookieModule.withOptions({path: '/', domain: '.day1cloud.com'})), provideRouter(routes)],
};
